import styled from '@emotion/styled';

/* eslint-disable-next-line */
export interface SurgeryMonitorComponentsProps {}

const StyledSurgeryMonitorComponents = styled.div`
  color: pink;
`;

export function SurgeryMonitorComponents(props: SurgeryMonitorComponentsProps) {
  return (
    <StyledSurgeryMonitorComponents>
      <h1>Welcome to SurgeryMonitorComponents!</h1>
    </StyledSurgeryMonitorComponents>
  );
}

export default SurgeryMonitorComponents;
